module.exports = __webpack_public_path__ + "static/BK-fd1fb8a9ccab52b24b4ea564077222d7.png";